import React from "react";
import {css} from "@emotion/react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {ARTICLE_TEST_IDS} from "@pg-mono/test-ids";

import {IArticleListArticle} from "../../actions/fetch_article_list";
import {BlogFeaturedCard} from "./BlogFeaturedCard";

interface IProps {
    articles: IArticleListArticle[];
    className?: string;
}

export const ArticleListFeaturedArticles: React.FC<IProps> = (props) => {
    const {className, articles} = props;
    return (
        <div className={className} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.FEATURED_ARTICLE_BOX}>
            <Text css={[mb(3), onDesktop(mb(4))]} variant="headline_2" as="div">
                Polecamy
            </Text>

            <div css={listContainer}>
                {articles.map((article, index) => (
                    <BlogFeaturedCard css={listItem} article={article} key={index} imageLoading={index === 0 ? "eager" : "lazy"} />
                ))}
            </div>
        </div>
    );
};

const listContainer = css`
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
`;

const listItem = css`
    &:not(:last-of-type) {
        ${mb(3)}
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {ARTICLE_TEST_IDS} from "@pg-mono/test-ids";

import {IArticleListArticle} from "../../actions/fetch_article_list";
import {BlogFeaturedCard} from "./BlogFeaturedCard";

interface IProps {
    articles: IArticleListArticle[];
    className?: string;
}

export const ArticleListFeaturedArticles: React.FC<IProps> = (props) => {
    const {className, articles} = props;
    return (
        <div className={className} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.FEATURED_ARTICLE_BOX}>
            <Text css={[mb(3), onDesktop(mb(4))]} variant="headline_2" as="div">
                Polecamy
            </Text>

            <div css={listContainer}>
                {articles.map((article, index) => (
                    <BlogFeaturedCard css={listItem} article={article} key={index} imageLoading={index === 0 ? "eager" : "lazy"} />
                ))}
            </div>
        </div>
    );
};

const listContainer = css`
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
`;

const listItem = css`
    &:not(:last-of-type) {
        ${mb(3)}
    }
`;
